<template>
    <div v-redirect-if-no-permission:SERVICES>
        <DataTable ref="datatable" :url="api.ACTIONS.CAMERA_STREAM_LOGS"
            :fieldsHiddenMain='["updated_at", "camera", "camera_id", "passenger_id", "user_id"]'
            :enableAdd="false" :enableEdit="false" :enableDelete="false"
            :formatter="formatter" :forceReload="true"
            :titles="titles" :title='$t("camerasPage.logsTitle")' />
    </div>
</template>

<script>

import DataTable from "@/components/monaco/DataTable";
import { formatCompanyTime } from "@/util/companyTime";

// Read-only "سجل البث" — every passenger attempt to open a Safe Ride camera
// stream, kept for dispute resolution (BRD 3.3-4).
export default {
    components: { DataTable },
    name: "CameraStreamLogs",
    title() {
        return this.$t("camerasPage.logsTitle");
    },
    computed: {
        formatter() {
            // Cells render through v-html — escape user- and vendor-controlled text.
            const esc = s => String(s == null ? "" : s)
                .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
                .replace(/"/g, "&quot;").replace(/'/g, "&#039;");
            return {
                passenger(value) {
                    if (!value) return "-";
                    return `${esc(value.full_name)} (${esc(value.phone_number)})`;
                },
                // The dashboard admin who opened a test view (null on passenger streams).
                user(value) {
                    if (!value) return "-";
                    return `${esc(value.first_name)} ${esc(value.last_name)}`;
                },
                error(value) {
                    return value ? esc(value) : "-";
                },
                success(value) {
                    return value
                        ? `<i class="fa fa-check" style="color: green"></i>`
                        : `<i class="fa fa-close" style="color: red"></i>`;
                },
                created_at(value) {
                    return formatCompanyTime(value, "YYYY-MM-DD HH:mm:ss");
                },
            }
        },
        titles() {
            return {
                "id": "#",
                "booking_id": this.$t("camerasPage.colBooking"),
                "passenger": this.$t("camerasPage.colPassenger"),
                "user": this.$t("camerasPage.colViewer"),
                "imei": this.$t("camerasPage.colImei"),
                "success": this.$t("camerasPage.colSuccess"),
                "error": this.$t("camerasPage.colError"),
                "created_at": this.$t("camerasPage.colRequestedAt"),
            }
        },
    },
}
</script>
